<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar @openAddAuth="openRobotForm" @search="fetchData" />

    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      height="750"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="关键字" align="center">
        <template slot-scope="scope">
          {{ scope.row.keyWord }}
        </template>
      </el-table-column>

      <el-table-column label="回答" align="center">
        <template slot-scope="scope">
          {{ scope.row.answer }}
        </template>
      </el-table-column>

      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.type == 1 ? '标准' : '普通' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="editCell(scope.row)"
              type="primary"
              v-if="roleList[path].includes('_Update')"
              >编辑</el-button
            >
          </div>
          <div class="lastBtn">
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="delCell(scope.row.chatWordId)"
              type="danger"
              v-if="roleList[path].includes('_Delete')"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 添加表单对话框 -->
    <robotForm ref="robotForm" @refshData="fetchData" />
  </div>
</template>

<script>
import { getChatWordApi, delChatWordApi } from '@/api/newsApi.js';
const robotForm = () => import('./components/robotForm'); // 增加表单
import Pagination from '@/components/Pagination'; // 分页
import SearchBar from './components/searchBar'; // 搜索框
import { mapGetters } from 'vuex';

export default {
  name: 'robot',
  components: {
    robotForm,
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      path: '',
    };
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },

  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData(obj = {}) {
      try {
        this.listLoading = true;
        let res = await getChatWordApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...obj,
        });
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.listLoading = false;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 打开增加表单
    openRobotForm(val) {
      this.$refs.robotForm.title = '新增';
      this.$refs.robotForm.dialogFormVisible = val;
    },

    // 编辑
    editCell(row) {
      let { keyWord, answer, type, chatWordId } = row;
      this.$refs.robotForm.robotForm = { keyWord, answer, type, chatWordId };
      this.$refs.robotForm.title = '编辑';
      this.$refs.robotForm.dialogFormVisible = true;
    },

    // 删除
    async delCell(id) {
      try {
        let res = await delChatWordApi(id);
        if (res.code !== 200) return;
        this.$message.success('删除成功！');
        // 判断是否当前页的最后一条数据
        let bol =
          this.totalCount - this.pageSize * this.pageIndex === 1 ? true : false;
        // 不是第一页就-1
        if (bol && this.pageIndex > 1) {
          this.$refs.Pagination.pageIndex--;
        } else {
          this.fetchData();
        }
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}
</style>
